import ChatIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import HomeIcon from '@mui/icons-material/Home';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import List from '@zenbusiness/zui/List';
import HelpListItem from '@zenbusiness/zui/PageError/HelpListItem';

const HELP_LIST_ITEMS = [
  {
    icon: ChatIcon,
    messageId: 'shopping.component.cartError.help.contact',
    url: 'https://www.zenbusiness.com/contact-us/'
  },
  {
    icon: HomeIcon,
    messageId: 'shopping.component.cartError.help.homepage',
    url: 'https://www.zenbusiness.com/'
  }
];

function HelpList() {
  return (
    <List>
      {HELP_LIST_ITEMS.map((item) => (
        <HelpListItem
          key={item.messageId}
          label={<FormattedMessage id={item.messageId} />}
          {...item}
        />
      ))}
    </List>
  );
}

export default HelpList;
